export default "__VITE_ASSET__Bhaj$dd1__"